import {Serializable, SerializedReport} from '../types/serialized-cohort-types';

export class Report implements Serializable {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  constructor(public behavior_params, public bookmark, public name) {}

  public serialize(): SerializedReport {
    return {
      behavior_params: this.behavior_params,
      bookmark: this.bookmark,
    };
  }
}
